import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';
import {
  CountryCodes,
  type FetchPhoneMetadataQueryQuery,
} from '@/generated/graphql';
import type { PhoneMetaData } from './types';
import { hasExactTreatment } from '@/lib/features/utils';
import { getLocale } from '@/lib';

export const mapPhoneMetadata = (
  data: FetchPhoneMetadataQueryQuery,
): PhoneMetaData => {
  const { localeMetadata } = data;
  const phone = localeMetadata?.phone;
  const masks = phone?.masks;
  const pattern = phone?.patterns?.default;

  const phoneMetadata = {
    mask: masks?.mobile,
    pattern: pattern?.substring(1, pattern.length - 1),
  };

  return phoneMetadata;
};

const infoMessageContainerOverrides = css`
  padding: 16px;
  gap: 12px;
  background: #faf8f5;
  border-radius: 6px;
  margin-bottom: 12px;
`;

const infoMessageOverrides = css`
  font-weight: 400;
  font-size: 14px;
  /* stylelint-disable-next-line declaration-no-important */
  margin-left: 0 !important;
  line-height: 20px;
  color: #001435;
`;

type MobielHintStyleOverrides = {
  container: SerializedStyles;
  message: SerializedStyles;
};

export const getMobileHintStyles = (): MobielHintStyleOverrides => {
  return {
    container: infoMessageContainerOverrides,
    message: infoMessageOverrides,
  };
};

export const US_TRMT_5_CONTENT_KEY = 'messages.paypalWillVerify';
export const DEFAULT_CONTENT_KEY = 'valueProps.phoneConfirmmation';

/**
 * Checks whether phone confirmation is in treatment 5 AND country is US.
 * If so, returns 'PayPal will text you a code to verify this number. Carrier fees may apply.'
 * Otherwise, returns 'We'll text a security code to confirm this number.'
 * @returns content key (string)
 */
export const getPhoneConfirmationContentKey = (): string => {
  const { country } = getLocale();

  return hasExactTreatment({
    feature: 'FEATURE_SIGNUP_MANDATORY_PHONE_CONFIRMATION',
    treatment: 'Trmt_FEATURE_SIGNUP_MANDATORY_PHONE_CONFIRMATION_5',
  }) && country === CountryCodes.Us
    ? US_TRMT_5_CONTENT_KEY
    : DEFAULT_CONTENT_KEY;
};
